module.exports = "/src/views/player/help/images/clot.png";